import { createStore } from 'vuex'

export default createStore({
    state: {
        aid: '62bbb449363bdb004cf0c91a', // 活动id
        musicPaused: false, // 音乐播放状态
        userInfo: {}, // 用户信息
        shareData: {}, // 分享信息
        dialogData: null, // 弹框数据
        activityData: null, // 活动数据
        page: 1,  // 页码
        step: 1,  // 步
        isMap: false,  // 是否已显示地图
    },
    mutations: {
        SET_MUSICPAUSED (state, flag: boolean) {
            state.musicPaused = flag
        },
        SET_USERINFO (state, data) {
            state.userInfo = data
        },
        SET_SHAREDATA (state, data) {
            state.shareData = data
        },
        SET_DIALOGDATA (state, data) {
            state.dialogData = data
        },
        SET_ACTIVITYDATA (state, data) {
            state.activityData = data
        },
        SET_PAGE (state, data) {
            state.page = data
        },
        SET_STEP (state, data) {
            state.step = data
        },
        SET_ISMAP (state, data) {
            state.isMap = data
        },
    },
    actions: {
    },
    modules: {
    }
})
